<section class="tabla-contenedor" *ngIf="mostrarBuscador">
    <mat-form-field appearance="outline" class="buscador">
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar..." #input />
        <button mat-icon-button matSuffix *ngIf="input.value" (click)="input.value=''; applyFilter($event)">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
</section>

<div class="table-responsive">
    <table mat-table [dataSource]="dataSource" matSort class="tabla-pro">
        <!-- 🔁 Columnas dinámicas -->
        <ng-container *ngFor="let col of columnas" [matColumnDef]="col.field">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ col.header }}</th>
            <td mat-cell *matCellDef="let row" [attr.data-label]="col.header">
                <!-- Si es columna 'avatarName' -->
                <ng-container *ngIf="col.type === 'avatarName'; else detailOrNormal">
                    <div class="user-avatar-cell">
                        <div class="avatar-bubble" [style.background]="getAvatarGradient(row[col.field])">
                            <img *ngIf="row['foto']" [src]="row['foto']" alt="Avatar">
                            <span *ngIf="!row['foto']">
                                {{ getInitials(row[col.field]) }}
                            </span>
                        </div>
                        <span class="user-name-text">{{ row[col.field] | titlecase }}</span>
                    </div>
                </ng-container>

                <!-- Si es columna 'detail' o normal -->
                <ng-template #detailOrNormal>
                    <ng-container *ngIf="col.type === 'detail'; else defaultCell">
                        <ng-container
                            *ngIf="row[col.field] && row[col.field].includes('Permisos asignados:'); else textoPlano">
                            <ng-container *ngIf="extraerJsonDeTexto(row[col.field]) as permisos">
                                <div *ngIf="permisos.length > 0" class="detalle-permisos">
                                    <div><strong>Rol ID:</strong> {{ extraerRolId(row[col.field]) }}</div>
                                    <ul style="margin: 0; padding-left: 1.2em;">
                                        <li *ngFor="let permiso of permisos">
                                            <strong>Ruta {{ permiso.idRuta }}:</strong>
                                            A: {{ permiso.agregar ? '✓' : '✗' }},
                                            E: {{ permiso.editar ? '✓' : '✗' }},
                                            El: {{ permiso.eliminar ? '✓' : '✗' }},
                                            Acceso: {{ permiso.acceso ? '✓' : '✗' }}
                                        </li>
                                    </ul>
                                </div>
                            </ng-container>
                        </ng-container>
                        <ng-template #textoPlano>{{ row[col.field] }}</ng-template>
                    </ng-container>
                </ng-template>

                <!-- Celda por defecto -->
                <ng-template #defaultCell>
                    <ng-container [ngSwitch]="col.pipe">
                        <ng-container *ngSwitchCase="'date'">
                            {{ row[col.field] | date:'HH:mm - dd-MM-yyyy' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'currency'">
                            {{ row[col.field] | currency:'CLP':'symbol':'1.0-0':'es-CL' }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ row[col.field] }}
                        </ng-container>
                    </ng-container>
                </ng-template>
            </td>
        </ng-container>

        <!-- ⚙️ Columna de acciones -->
        <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let row" [attr.data-label]="'Acciones'">

                <!-- ✅ Si el componente padre pasa un template -->
                <ng-container *ngIf="accionesTemplate; else defaultActions" [ngTemplateOutlet]="accionesTemplate"
                    [ngTemplateOutletContext]="{ $implicit: row }">
                </ng-container>

                <ng-template #defaultActions>
                    <div class="acciones-cell-wrapper">
                        <button *ngIf="puedeEditar" mat-icon-button color="accent" (click)="edit(row)" matTooltip="Editar">
                            <mat-icon>edit</mat-icon>
                        </button>

                        <button *ngIf="puedeEliminar && (!canEliminarCompra || canEliminarCompra(row))" mat-icon-button
                            color="warn" (click)="delete(row)" matTooltip="Eliminar">
                            <mat-icon>delete</mat-icon>
                        </button>

                        <button *ngIf="puedePagar && (row.state ?? '').toString().toLowerCase().trim() === 'pendiente'"
                            mat-icon-button color="accent" (click)="pagarProducto(row)" matTooltip="Pagar">
                            <mat-icon>attach_money</mat-icon>
                        </button>

                        <button *ngIf="puedeCambiarPassword" mat-icon-button color="accent" (click)="cambiarPassword(row)"
                            matTooltip="Cambiar contraseña">
                            <mat-icon>vpn_key</mat-icon>
                        </button>
                    </div>
                </ng-template>
            </td>
        </ng-container>

        <!-- Filas -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>

<!-- 🔸 Mensaje sin resultados -->
<div *ngIf="sinResultados" class="sin-resultados">
    <mat-icon color="warn">info</mat-icon>
    <span>Información no encontrada</span>
</div>

<!-- 📄 Paginador -->
<br>
<mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>